<template>
  <div :style="$parent.mobileBackground">
    <section class="section">

      <app-logo class="mt-5"/>

      <div class="card">
        <div class="card-content has-text-centered">
          <p class="has-text-weight-bold pb-2">{{$t('system.inactivityTitle')}}</p>
          <p class="is-size-7">{{$t('system.inactivityDesc')}}</p>
        </div>
        <footer class="card-footer p-4">
          <b-button
          type="is-primary"
          size="is-small"
          :label="$t('system.inactivityButton')"
          @click="Reload()"
          expanded/>
        </footer>
      </div>
        
    </section>
  </div>
</template>

<script scoped>
  export default {
    data() {
      return {};
    },
    methods: {
      Reload() {
        window.location.href="/";
      },
    },
    mounted(){
      console.log("Inactivity mounted")
      // Closing socket connection
      this.$store.commit("SetdisableReconnectingAlert", true);
      this.$socket.client.close();
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

section {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1em;
  background-color: $system-screen-background;
}

.card {
    @include blurBox();
}
</style>